import { render, staticRenderFns } from "./templeteWrite.vue?vue&type=template&id=a64fe406"
import script from "./templeteWrite.vue?vue&type=script&lang=js"
export * from "./templeteWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports